import { render } from "./InternalServerError.vue?vue&type=template&id=51a2309b&ts=true"
import script from "./InternalServerError.vue?vue&type=script&lang=ts"
export * from "./InternalServerError.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__